import * as React from 'react';
import Paragraph from "../text/paragraph";
import Td from "./td";
import styled from "styled-components";

interface IProps
    extends React.DetailedHTMLProps<React.TdHTMLAttributes<HTMLTableDataCellElement>, HTMLTableDataCellElement> {
}

const TdWithText: React.FC<IProps> = (props) => {

    const { children, ref, ...TdProps } = props;

    return(
        <Td {...TdProps} >
            <TdText>{children}</TdText>
        </Td>
    );

};

export default TdWithText;

const TdText = styled(Paragraph)`
`;


// WEBPACK FOOTER //
// ./src/presentation/common/atom/table/td_with_text.tsx